export default __webpack_public_path__ + "static/media/alertExample.1eb12bc7.png";